<template>
   <svg name="closex" viewBox="0 0 14 13" fill="none" aria-hidden="true" focusable="false">
      <line x1="1.25492" y1="0.989449" x2="12.5686" y2="12.3032" stroke="#1C2B33" stroke-width="1.5" />
      <line x1="1.4316" y1="12.3029" x2="12.7453" y2="0.989217" stroke="#1C2B33" stroke-width="1.5" />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
